import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { SubjectFormValues } from "src/models/Subject.model";
import Subject from "../Layouts/SubjectForm";
import {
  useGetSubjectByIdQuery,
  useUpdateSubjectByIdMutation,
} from "src/services/SubjectService";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  selectedSubjectId: string;
};

const EditSubjectWrapper = ({ onClose, selectedSubjectId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetSubjectByIdQuery(selectedSubjectId);
  const [updateSubjectByID] = useUpdateSubjectByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: SubjectFormValues = {
    subjectName: items?.subjectName || "",
  };
  // Validation Schema
  const validationSchema = object().shape({
    subjectName: string().required("Please enter subject name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: SubjectFormValues,
    { setSubmitting, resetForm }: FormikHelpers<SubjectFormValues>
  ) => {
    updateSubjectByID({ id: selectedSubjectId, body: values }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Subject
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditSubjectWrapper;
